import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedService } from '../../../shared/shared.service';
import { AdminDevoteeService } from '../../services/admin-devotee.service';
import { AdminPrasadOrderService } from '../../services/admin-prasad-order.service';

@Component({
  selector: 'app-prasad-order-report',
  templateUrl: './prasad-order-report.component.html',
  styleUrls: ['./prasad-order-report.component.css'],
  providers: [AdminPrasadOrderService]
})
export class PrasadOrderReportComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private adminPrasadOrderService: AdminPrasadOrderService) { }

  searchForm: FormGroup;
  prasadOrderReports: any[] = [];
  errorMessage: string;

  ngOnInit() {
    this.createSearchForm();
  }


  devoteeSearch() {

    let searchGridEntity = this.searchForm.value;

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.prasadOrderSummaryReport(searchGridEntity).subscribe(
      data => {
        this.prasadOrderReports = data;
      },
      err => this.errorMessage = err,
      () => this.sharedService.hideSpinner()
    )

  }

  createSearchForm(): void {
    this.searchForm = this.formBuilder.group({
      FromDate: [],
      ToDate: [],
      AmountRange: []
    });
  }

  totalCount() {
    return this.prasadOrderReports.map(x => x.Count)
      .reduce((prev, next) => prev + next)
  }

  totalAmount() {
    return this.prasadOrderReports.map(x => x.Amount)
      .reduce((prev, next) => prev + next)
  }


}



// WEBPACK FOOTER //
// ./src/app/admin/components/prasad-order-report/prasad-order-report.component.ts